import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Demo2ZoneMap from '../Demo2ZoneMap';
import { useDemo2Ctx } from '../Demo2Context';
import { STATUS_LABEL, STATUS_COLOR, treeIconRi } from '../demo2Data';

export default function Demo2MMap() {
    const navigate = useNavigate();
    const { zones } = useDemo2Ctx();
    const danger = zones.find(z => z.status === 'danger') ?? zones[0];
    const [selectedId, setSelectedId] = useState<string>(danger.id);
    const z = zones.find(zz => zz.id === selectedId) ?? zones[0];
    const c = STATUS_COLOR[z.status];

    return (
        <>
            <div className="m-header"><div className="m-header-ttl">수목 지도</div></div>
            <div style={{ flex: 1, position: 'relative', overflow: 'hidden' }}>
                <Demo2ZoneMap zones={zones} selectedId={selectedId} onSelectZone={setSelectedId} zoom={16} mapTypeToggle defaultMapType="SATELLITE" toggleAnchor="top-right" showWeather />
                <div style={{ position: 'absolute', top: 12, left: 12, right: 12, zIndex: 5 }}>
                    <div className="m-gps-badge"><i className="ri-map-pin-line" /> 내 위치 : {z.district} 현장 인근 · 반경 500m 표시</div>
                </div>
                <div style={{ position: 'absolute', left: 12, right: 12, bottom: 12, zIndex: 6 }}>
                    <div className="m-card" style={{ margin: 0, boxShadow: '0 10px 30px rgba(0,0,0,0.18)' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                            <span style={{ fontSize: 13.5, fontWeight: 800, display: 'flex', alignItems: 'center', gap: 8 }}>
                                <span className="d2-ico d2-ico-sm d2-ico-green"><i className={treeIconRi(z.treeName)} /></span>
                                {z.name}
                            </span>
                            <span className={`badge badge-${z.status}`}>{STATUS_LABEL[z.status]}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 11 }}>
                            <div style={{ flex: 1, height: 6, background: 'var(--surface3)', borderRadius: 4, overflow: 'hidden' }}>
                                <div style={{ width: `${z.moist}%`, height: '100%', background: c, borderRadius: 4 }} />
                            </div>
                            <span style={{ fontFamily: 'var(--mono)', fontWeight: 800, fontSize: 13, color: c, flexShrink: 0 }}>{z.moist}%</span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: 'var(--text3)', marginBottom: 11, fontWeight: 600 }}>
                            <span><i className="ri-leaf-line" /> {z.category}</span><span><i className="ri-user-3-line" /> 담당 {z.mgr}</span>
                        </div>
                        <button className="btn btn-primary w-full btn-sm" onClick={() => navigate('/demo2/mobile/worklist')}><i className="ri-drop-line" /> 관개 작업 등록</button>
                    </div>
                </div>
            </div>
        </>
    );
}
